export default {
  enums: [
    { id: 'FOREIGN' },
    { id: 'LOCAL' },
    { id: 'REMAINS' },
    { id: 'CROSSBORDER' },
    { id: 'REMARK' },
  ]
};